<template>
  <div id="app">
    <van-tabbar v-model="actived">
      <van-tabbar-item icon="label-o" @click="tab('/')">最新活动</van-tabbar-item>
      <van-tabbar-item icon="orders-o" @click="tab('/orders')">我的订单</van-tabbar-item>
      <van-tabbar-item icon="user-o" @click="tab('/mine')">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data () {
    return {
      actived: this.active
    }
  },
  methods: {
    tab (path) {
      this.$router.push({path: path})
    }
  },
  props: ['active']
}
</script>



// WEBPACK FOOTER //
// src/components/TabBar.vue